import { API } from "@/main.js";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  fetchLabels({ commit }, { rowsPerPage, page, sort, filters }) {
    return new Promise((resolve, reject) => {
      API.label.getAll(
        rowsPerPage,
        page,
        sort,
        filters,
        resp => {
          resolve(resp.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchLabelByUUID({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.label.getByUUID(
        uuid,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  addLabels({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.label.createInBulk(
        data,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  editLabels({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.label.updateInBulk(
        data,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteLabels({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.label.deleteInBulk(
        data,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  deleteLabel({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.label.delete(
        uuid,
        resp => {
          resolve(resp.data.data[0]);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Management/labels.js